import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ContactForm from '../ContactForm';
import { BookOpen, Users, Workflow, CheckCircle, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../components/PageHeader';

const GuiaIntegracionPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [formConfig, setFormConfig] = useState({ scriptSrc: '', formData: '', formId: '' });

  const openContactPopup = () => {
    setIsPopupOpen(true);
    setFormConfig({
      scriptSrc: 'https://cdn.bitrix24.es/b24284919/crm/form/loader_60.js',
      formData: 'inline/60/04yfgs',
      formId: '60',
    });
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setFormConfig({ scriptSrc: '', formData: '', formId: '' });
  };

  return (
    <div className="min-h-screen bg-white">
      <PageHeader onOpenPopup={openContactPopup} />

      <main className="pt-20">
        <section className="py-16 px-4 sm:px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <button
              type="button"
              onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
              className="inline-flex items-center text-sm text-gray-600 hover:text-[#141414] mb-6"
            >
              <ArrowLeft className="mr-2" size={18} />
              {t('guia_integracion.back')}
            </button>
            <div className="text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-[#141414] mb-3">
                {t('guia_integracion.title')}
              </h1>
              <p className="text-lg text-gray-600">
                {t('guia_integracion.subtitle')}
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mb-12">
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <BookOpen className="text-[#141414] mb-3" />
                <div className="font-semibold text-[#141414] mb-1">{t('guia_integracion.items.methodology.title')}</div>
                <div className="text-sm text-gray-600">{t('guia_integracion.items.methodology.desc')}</div>
              </div>
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <Users className="text-[#141414] mb-3" />
                <div className="font-semibold text-[#141414] mb-1">{t('guia_integracion.items.collaboration.title')}</div>
                <div className="text-sm text-gray-600">{t('guia_integracion.items.collaboration.desc')}</div>
              </div>
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <Workflow className="text-[#141414] mb-3" />
                <div className="font-semibold text-[#141414] mb-1">{t('guia_integracion.items.traceability.title')}</div>
                <div className="text-sm text-gray-600">{t('guia_integracion.items.traceability.desc')}</div>
              </div>
            </div>

            <div className="text-center">
              <button
                onClick={openContactPopup}
                className="bg-[#141414] text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition"
              >
                {t('guia_integracion.cta_guide')}
              </button>
              <div className="mt-3 text-sm text-gray-600 flex items-center justify-center gap-2">
                <CheckCircle className="text-green-600" size={16} />
                {t('guia_integracion.cta_desc')}
              </div>
            </div>
          </div>
        </section>

        {isPopupOpen && (
          <section className="py-10 px-4 sm:px-6">
            <div className="max-w-3xl mx-auto bg-white rounded-2xl p-6 border border-gray-200">
              <div className="text-center mb-6">
                <h2 className="text-2xl font-bold text-[#141414]">{t('guia_integracion.form_title')}</h2>
                <p className="text-gray-600">
                  {t('guia_integracion.form_desc')}
                </p>
              </div>
              <ContactForm
                scriptSrc={formConfig.scriptSrc}
                formData={formConfig.formData}
                formId={formConfig.formId}
              />
              <div className="mt-4 text-center">
                <button
                  onClick={closePopup}
                  className="text-sm text-gray-600 hover:text-[#141414] underline"
                >
                  {t('guia_integracion.form_close')}
                </button>
              </div>
            </div>
          </section>
        )}
      </main>
    </div>
  );
};

export default GuiaIntegracionPage;

